// Vendors
import React from 'react';
import { BrowserRouter } from 'react-router-dom-v6';
// Constants
import { ROUTER_PROPS, THEME_PROVIDER_PROPS } from './constants/entrypoint.constants';
// Entrypoint common
import EntrypointCommon from 'entrypoint/entrypoint.common';
// Providers
import MobileConnectorContextProvider from 'providers/mobile-connector/contexts/mobile-connector.provider.context';
import ThemeProvider from 'providers/theme/theme.provider';
import { PublicInteractionsProvider } from 'providers/public-interactions/public-interactions.provider';

const Entrypoint = (): React.ReactElement => (
  <ThemeProvider {...THEME_PROVIDER_PROPS}>
    <BrowserRouter {...ROUTER_PROPS}>
      <MobileConnectorContextProvider>
        <PublicInteractionsProvider>
          <EntrypointCommon />
        </PublicInteractionsProvider>
      </MobileConnectorContextProvider>
    </BrowserRouter>
  </ThemeProvider>
);

export default Entrypoint;
